import React from 'react';
import { Button } from 'antd';
import styled, { css } from 'styled-components';
import classNames from 'classnames';

type ButtonType = 'link' | 'text' | 'default' | 'primary' | 'ghost' | 'dashed';

const Wrap = styled.div<{ border?: string; padding?: string; bgColor?: string; color?: string; maxWidth?: string; width: string }>`
  font-family: 'Roboto';
  .anticon svg {
    display: block;
  }
  .divider {
    height: 22px;
    margin: 0 6px;
    border-color: #ffffff80;
  }
  span#custom-icon {
    display: flex;
  }
  .global-custom-btn-style:hover {
    opacity: 0.9;
  }
  .btnDisable {
    opacity: 0.5;
  }
  .btnDisable:hover {
    opacity: 0.5 !important;
  }
  ${(props) =>
    props.border &&
    css`
      .global-btn-style {
        display: block;
        align-items: center;
        font-family: 'Roboto';
        font-weight: 500;
        max-height: 38px;
        height: 38px;
        line-height: 20px;
        border: ${props.border};
        background: ${props.bgColor};
        color: ${props.color};
        padding: ${props.padding || '8px 16px'};
        max-width: ${props.maxWidth};
        width: ${props.width};
        gap: 10px;
      }
      .global-btn-style:hover {
        opacity: 0.9;
      }
    `}
  @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    .global-btn-style {
      font-size: 13px !important;
      padding: 4px 8px !important;
    }
  }
`;

interface ButtonProps {
  btnText?: string;
  icon?: React.ReactChild;
  buttonType: 'type' | 'custom';
  btnType: ButtonType;
  disabled: boolean;
  loading?: boolean;
  onClick: () => void;
  border?: string;
  padding?: string;
  bgColor?: string;
  color?: string;
  customIcon?: React.ReactChild;
  borderRadius?: string;
  fontSize?: string;
  boxShadow?: string;
  maxWidth?: string;
  width?: string;
}

const customClass: (props: {
  bgColor?: string;
  border?: string;
  color?: string;
  padding?: string;
  fontSize?: string;
  boxShadow?: string;
  borderRadius?: string;
  maxWidth?: string;
  width?: string;
}) => React.CSSProperties = (props) => ({
  background: props.bgColor,
  maxHeight: '38px',
  height: '38px',
  border: props.border,
  color: props.color,
  padding: props.padding,
  fontSize: props.fontSize,
  boxShadow: props.boxShadow,
  borderRadius: props.borderRadius || '4px',
  maxWidth: props.maxWidth,
  width: props.width,
});

const GlobalAntButton: React.FC<ButtonProps> = (props) => {
  const { btnType, disabled, icon, loading, onClick, maxWidth, width, btnText, border, padding, bgColor, color, borderRadius, fontSize, boxShadow } =
    props;

  return (
    <Wrap border={border} padding={padding} bgColor={bgColor} color={color} maxWidth={maxWidth} width={width}>
      <Button
        className={classNames('global-btn-style', { btnDisable: disabled })}
        type={btnType}
        disabled={disabled}
        icon={icon}
        loading={loading}
        onClick={onClick}
        style={customClass({
          bgColor,
          border,
          color,
          padding,
          fontSize,
          boxShadow,
          borderRadius,
          maxWidth,
          width,
        })}
      >
        {btnText}
      </Button>
    </Wrap>
  );
};

export default GlobalAntButton;
